import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {UrlBuilderService} from './url-builder.service';
import {QueryParams} from '../types/QueryParams';
import {Router} from '@angular/router';
import {MetaTag} from '../types/MetaTag';
import {SeoMetaService} from './seo-meta.service';
import {isPlatformBrowser} from '@angular/common';
import {RoutesEnums} from '../enums/RoutesEnums';

@Injectable()
export class RedirectService {
  constructor(
    private metaService: SeoMetaService,
    private urlBuilder: UrlBuilderService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {}

  public redirect(routeLinkTab: string[], queryParams?: QueryParams, replaceUrl?: boolean, fragment?: string): void {
    const url: string = this.urlBuilder.CreateStaticLink(routeLinkTab, queryParams);
    if (routeLinkTab.includes(RoutesEnums.NOTFOUND)) {
      this.set404MetaTag(url);
    } else {
      this.setRedirectMetaTag(url);
    }

    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate(routeLinkTab, {
        queryParams: queryParams,
        replaceUrl: replaceUrl,
        fragment: fragment,
      });
    }
  }

  private setRedirectMetaTag(url: string): void {
    const metaTags: MetaTag[] = [];
    metaTags.push({
      value: `Location: ${encodeURI(decodeURI(url))}`,
      type: 'name',
      field: 'ssr-redirect',
    });
    this.metaService.updateMetaTags(metaTags);
  }

  private set404MetaTag(url: string): void {
    const metaTags: MetaTag[] = [];
    metaTags.push({
      value: `Location: ${encodeURI(decodeURI(url))}`,
      type: 'name',
      field: 'ssr-404',
    });
    this.metaService.updateMetaTags(metaTags);
  }
}
